var _defs, _rect, _g, _line, _text, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoofhubPoweredByGoodleapMaroon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 700 220",
    width: 700,
    height: 220,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gl-lg1",
    x1: 202.9,
    y1: -596.45,
    x2: 202.9,
    y2: -717.15,
    gradientTransform: "translate(0 -612) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#edb550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f1aa3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fb8e11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff8300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gl-lg2",
    x1: 234.65,
    y1: -596.45,
    x2: 234.65,
    y2: -717.15,
    gradientTransform: "translate(0 -612) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#edb550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f1aa3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fb8e11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff8300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gl-lg3",
    x1: 283.7,
    y1: -596.45,
    x2: 283.7,
    y2: -717.15,
    gradientTransform: "translate(0 -612) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#edb550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f1aa3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fb8e11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff8300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gl-lg4",
    x1: 335.35,
    y1: -596.45,
    x2: 335.35,
    y2: -717.15,
    gradientTransform: "translate(0 -612) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#edb550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f1aa3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fb8e11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff8300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gl-lg5",
    x1: 68.64,
    y1: -657.89,
    x2: 122.4,
    y2: -657.89,
    gradientTransform: "translate(0 -612) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ff7b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ff9a11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ffaf1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gl-lg6",
    x1: 68.64,
    y1: -657.89,
    x2: 122.36,
    y2: -657.89,
    gradientTransform: "translate(0 -612) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ff8300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fa9f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f7b334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gl-lg7",
    x1: 358.33,
    y1: 21.43,
    x2: 367.23,
    y2: 21.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#edb550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f1aa3e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "divider-grad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#ffffff",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 220,
    fill: "#762123"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38, 42) scale(0.56)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M38.44,162.63l-12.64-27.16h-9.05v27.16H0v-75h31.09c15.2,0,25.28,9.91,25.28,23.75,0,12.98-7.69,19.47-14.52,21.53l15.2,29.72h-18.62ZM28.53,100.79h-11.79v21.53h11.79c6.49,0,10.76-4.44,10.76-10.76,0-6.66-4.1-10.76-10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M95.15,86.27c21.87,0,34.85,16.57,34.85,38.78s-12.98,38.78-34.85,38.78-34.68-16.4-34.68-38.78,12.98-38.78,34.68-38.78ZM95.15,99.77c-11.45,0-17.43,10.93-17.43,25.45s6.15,25.45,17.43,25.45,17.77-11.1,17.77-25.45-6.15-25.45-17.77-25.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M167.93,86.27c21.87,0,34.85,16.57,34.85,38.78s-12.98,38.78-34.85,38.78-34.68-16.4-34.68-38.78,12.98-38.78,34.68-38.78ZM167.93,99.77c-11.45,0-17.43,10.93-17.43,25.45s6.15,25.45,17.43,25.45,17.77-11.1,17.77-25.45-6.32-25.45-17.77-25.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M209.27,162.63v-75h47.66v13.15h-30.92v17.25h30.07v12.98h-30.07v31.6h-16.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M329.02,162.63v-31.95h-27.67v31.95h-16.74v-75h16.74v29.72h27.67v-29.72h16.91v75h-16.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M355.67,87.64h16.91v49.2c0,8.88,4.78,13.84,13.67,13.84s13.67-4.95,13.67-13.84v-49.2h16.91v49.2c0,17.25-11.62,27.16-30.41,27.16s-30.41-9.91-30.41-27.16v-49.2h-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M426.4,162.63v-75h34.51c14.86,0,22.04,8.88,22.04,19.13,0,9.4-5.81,15.55-13.33,17.25,8.54,1.2,14.69,9.05,14.69,18.45,0,11.45-7.18,20.33-22.21,20.33h-35.7v-.17ZM443.14,118.05h13.67c5.98,0,8.88-3.76,8.88-8.71s-2.9-8.88-8.88-8.88h-13.67v17.6ZM443.14,149.82h14.35c6.32,0,9.57-3.59,9.57-9.4,0-5.12-3.25-9.4-9.57-9.4h-14.35v18.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M9.57,66.11h89.86c2.73,0,5.3-.51,7.86-1.37L282.22,1.02c.51-.17.51-1.02-.17-1.02h-89.86c-2.73,0-5.29.51-7.86,1.37L9.22,64.92c-.51.34-.34,1.2.34,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M297.25,4.27l-46.98,17.08c-.51.17-.51.85,0,1.02l116,42.2c2.56.85,5.12,1.37,7.86,1.37h89.86c.68,0,.85-.85.17-1.03L297.59,4.27h-.34Z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 318,
    y1: 55,
    x2: 318,
    y2: 165,
    stroke: "url(#divider-grad)",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 344,
    y: 97,
    fontFamily: "'Lato', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "rgba(255,255,255,0.65)",
    letterSpacing: 2.8
  }, "POWERED BY")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(334, 106) scale(0.87)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#gl-lg1)",
    d: "M200.2,2h5.4c1.1,0,2,.9,2,2v62.1c0,1.1-.9,2-2,2h-5.4c-1.1,0-2-.9-2-2V4c0-1.1,.9-2,2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gl-lg2)",
    d: "M235,24c-12.8,0-22.1,9.4-22.1,22.4s9.3,22.6,22.1,22.6c8.4,0,15.4-3.7,19.1-10.1,.5-1,.2-2.2-.7-2.7-.1,0-.2-.1-.3-.1l-2-.7c-.9-.3-1.7-.6-2.5-.9-.8-.4-1.8-.1-2.3,.6-2.5,3.5-6.7,5.5-11,5.3-6.4,0-11.2-3.6-12.7-9.3,0-.2,0-.4,.1-.6,.1-.2,.4-.3,.6-.3h31.1c1.1,0,2-.8,2-1.9v-1.9c0-13.2-8.8-22.4-21.4-22.4Zm11.7,18.3c-.1,.2-.4,.3-.6,.3h-22.8c-.4,0-.7-.3-.7-.8v-.2c1.4-5.6,6.2-9.1,12.4-9.1s10.5,3.4,11.9,9.1c0,.3-.1,.5-.2,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gl-lg3)",
    d: "M304.4,24.9h-5.4c-1.1,0-1.9,.9-2,2v1.2c0,.4-.3,.7-.7,.7-.2,0-.4-.1-.5-.2-3.6-3.1-8.2-4.7-12.9-4.6-12.7,0-21.9,9.5-21.9,22.5s9.4,22.5,21.9,22.5c4.7,0,9.3-1.7,12.9-4.8,.3-.3,.7-.3,1,0,.1,.1,.2,.3,.2,.5v1.4c0,1.1,.9,2,2,2h5.4c1.1,0,2-.9,2-2V26.8c0-1.1-.9-1.9-2-1.9Zm-20.8,34.9c-7.5,0-13.1-5.8-13.1-13.4s5.5-13.1,13.1-13.1c6.6,0,13.3,4.5,13.3,13.1,0,9.2-6.9,13.4-13.3,13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gl-lg4)",
    d: "M336.3,24c-4.7-.1-9.3,1.7-12.8,4.8-.3,.3-.8,.3-1,0-.1-.1-.2-.3-.2-.5v-1.5c0-1.1-.9-2-2-2h-5.5c-1.1,0-2,.9-2,2v59.7c0,1.1,.9,2,2,2h5.5c1.1,0,2-.9,2-2v-21.6c0-.3,.2-.6,.4-.7,.3-.1,.6-.1,.8,.1,3.6,3.1,8.1,4.7,12.8,4.6,12.5,0,21.6-9.4,21.6-22.4,.1-13-9-22.5-21.6-22.5Zm-.8,35.8c-6.5,0-13.1-4.5-13.1-13.1,0-9.3,6.8-13.5,13.1-13.5,7.5,0,13,5.7,13,13.5s-5.3,13.1-13,13.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gl-lg5)",
    d: "M122.4,25.3c0-.9-.7-1.7-1.6-1.7h-.1c-1.7-.2-3.4-.2-5.1-.1l-1,.1c-6.3,.7-12,4.1-15.7,9.3l-14.5,20.6c-2.2,3.4-6,5.5-10,5.6h-.1c-.5,0-.9,.3-1.2,.7h0l-.1,.1-4,5.6c-.6,.7-.4,1.8,.3,2.3,.2,.1,.3,.2,.5,.3h.1c2.2,.2,4.4,.3,6.6,.2,6.3-.8,12-4.2,15.7-9.3l14.4-20.4c2.3-3.1,5.8-5.1,9.7-5.4h.1c.6,0,1.2-.3,1.5-.9l4.2-6c.1-.3,.2-.6,.3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M44.2,24.8h-5.4c-1.1,0-2,.9-2,2v1.5c0,.4-.3,.7-.7,.7-.2,0-.4-.1-.5-.2-3.6-3.2-8.1-4.9-12.9-4.8-12.5-.1-21.9,9.7-21.9,22.6s9.2,22.4,21.9,22.4c5.9,0,11.3-2.4,14.2-6.4-.2,11.7-4.9,17.4-14.3,17.4-4.4,0-8.5-2.2-11-5.9-.5-.8-1.6-1.1-2.5-.7-1.3,.7-3.2,1.7-4.5,2.4-.5,.3-.9,.7-1,1.2-.2,.5-.1,1.1,.2,1.5,4,6.6,11.2,10.6,18.8,10.5,15.6,0,23.5-9.4,23.5-28V26.8c0-1.1-.8-1.9-1.9-2ZM23.4,59.7c-7.6,0-13.1-5.4-13.1-13.2s5.6-13.3,13.1-13.3c6.4,0,13.4,4.2,13.4,13.3,0,8.6-6.9,13.2-13.4,13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M187,2h-5.4c-1.1,0-2,.9-2,2V27.9c0,.3-.2,.6-.5,.7s-.6,.1-.8-.1c-3.1-2.9-7.8-4.5-12.9-4.5-12.6,0-21.7,9.4-21.7,22.5s9.4,22.5,21.8,22.5c4.7,0,9.3-1.6,12.9-4.7,.3-.3,.8-.3,1.1,0,.1,.1,.2,.3,.2,.5v1.3c0,1.1,.9,2,2,2h5.4c1.1,0,2-.9,2-2V4c-.1-1.1-1-2-2.1-2Zm-7.5,44.3c0,9.2-6.9,13.4-13.3,13.4-7.4,0-13-5.8-13-13.4s5.5-13.1,13-13.1c6.6,0,13.3,4.5,13.3,13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M135.1,32.5c-.3-.4-.7-.9-1-1.3-.1-.1-.2-.2-.3-.3-.6-.7-1.3-1.4-2-2h0c-.3-.3-.7-.5-1.2-.5s-1,.2-1.3,.6h0l-3.7,5.2h0c-.2,.3-.3,.6-.3,1,0,.5,.2,.9,.5,1.2h0c.9,.8,1.6,1.7,2.2,2.7,1,1.7,1.7,3.6,1.9,5.6,0,.3,.1,.7,.1,1v.3c0,7.1-5.8,12.9-12.9,12.9h0c-4.2,0-8.1-2-10.5-5.4l-14.5-20.5c-7.2-10.1-21.2-12.5-31.3-5.3-5.9,4.2-9.4,11-9.4,18.3,0,.8,0,1.5,.1,2.2v.1c.1,.7,.2,1.5,.3,2.2v.1c1,4.7,3.5,8.9,7.1,12.1,.3,.4,.8,.6,1.3,.6,.7,0,1.3-.4,1.6-1h0l3.3-4.7c.5-.7,.5-1.6-.1-2.2h0c-.6-.6-1.1-1.2-1.6-1.9-1.6-2.3-2.4-5-2.4-7.7-.1-3.4,1.2-6.6,3.6-9,5-5.1,13.2-5.2,18.3-.2,.6,.5,1.1,1.1,1.5,1.8l14.5,20.6c7.2,10.1,21.2,12.4,31.3,5.2s12.4-21.2,5.2-31.3c-.1-.1-.2-.2-.3-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gl-lg6)",
    d: "M122.4,25.3c0-.9-.7-1.7-1.6-1.7h0c-1.7-.2-3.4-.2-5.1-.1l-1,.1c-6.3,.7-12.1,4.1-15.7,9.3l-14.6,20.6c-2.2,3.4-6,5.5-10,5.6h-.1c-.5,0-.9,.3-1.2,.7h0l-.1,.1c-.9,1.2-2.7,3.8-3.9,5.6-.2,.3-.3,.6-.3,1,0,.7,.5,1.3,1.2,1.6h.1c2.2,.2,4.4,.3,6.6,.2,6.3-.8,12-4.2,15.7-9.3l14.4-20.4c2.3-3.1,5.8-5.1,9.7-5.4h.1c.6,0,1.2-.3,1.5-.8l4.2-6c-.1-.4,0-.7,.1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gl-lg7)",
    d: "M367.23,21.43c0,2.48-1.97,4.49-4.45,4.49s-4.44-2.01-4.44-4.49,1.96-4.51,4.44-4.51,4.45,2.02,4.45,4.51Zm-.61,0c0-2.14-1.71-3.9-3.84-3.9s-3.84,1.76-3.84,3.9,1.69,3.88,3.84,3.88,3.84-1.74,3.84-3.88Zm-3.25,.65l1.11,1.62h-.71l-1.09-1.58h-.71v1.58h-.64v-4.48h1.69c.99,0,1.43,.69,1.43,1.43s-.32,1.29-1.07,1.44Zm-1.41-2.27v1.72h1.03c.59,0,.83-.43,.83-.85s-.24-.87-.81-.87h-1.04Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofhubPoweredByGoodleapMaroon);
export default __webpack_public_path__ + "static/media/roofhub-powered-by-goodleap-maroon.178ef0bc8307ca67ff219b55ea7d7762.svg";
export { ForwardRef as ReactComponent };